<template>
  <div class="he-bazi-panel">
    <!-- 输入区域 -->
    <div class="persons-input">
      <!-- Person A -->
      <div class="person-card">
        <div class="person-card-title">
          <span class="person-icon">🧑</span> 方位甲
        </div>
        <div class="person-form">
          <div class="date-row">
            <el-select v-model="personA.year" placeholder="年" filterable clearable size="default" class="date-select">
              <el-option v-for="y in yearOptions" :key="y" :label="y + '年'" :value="y" />
            </el-select>
            <el-select v-model="personA.month" placeholder="月" clearable size="default" class="date-select">
              <el-option v-for="m in 12" :key="m" :label="m + '月'" :value="m" />
            </el-select>
            <el-select v-model="personA.day" placeholder="日" clearable size="default" class="date-select">
              <el-option v-for="d in daysInMonthA" :key="d" :label="d + '日'" :value="d" />
            </el-select>
          </div>
          <div class="hour-row">
            <el-select v-model="personA.hour" placeholder="时辰" clearable size="default" class="hour-select">
              <el-option label="子时 (23-01)" value="23" />
              <el-option label="丑时 (01-03)" value="1" />
              <el-option label="寅时 (03-05)" value="3" />
              <el-option label="卯时 (05-07)" value="5" />
              <el-option label="辰时 (07-09)" value="7" />
              <el-option label="巳时 (09-11)" value="9" />
              <el-option label="午时 (11-13)" value="11" />
              <el-option label="未时 (13-15)" value="13" />
              <el-option label="申时 (15-17)" value="15" />
              <el-option label="酉时 (17-19)" value="17" />
              <el-option label="戌时 (19-21)" value="19" />
              <el-option label="亥时 (21-23)" value="21" />
            </el-select>
          </div>
          <!-- 四柱八字表格 -->
          <div v-if="baziA" class="bazi-table-wrap">
            <table class="bazi-preview-table">
              <thead>
                <tr>
                  <th></th>
                  <th>年柱</th>
                  <th>月柱</th>
                  <th>日柱</th>
                  <th>时柱</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="label-cell">天干</td>
                  <td><span class="pillar-char" :class="getElementClass(baziA.year?.[0])">{{ baziA.year?.[0] || '-' }}</span></td>
                  <td><span class="pillar-char" :class="getElementClass(baziA.month?.[0])">{{ baziA.month?.[0] || '-' }}</span></td>
                  <td><span class="pillar-char" :class="getElementClass(baziA.day?.[0])">{{ baziA.day?.[0] || '-' }}</span></td>
                  <td><span class="pillar-char" :class="getElementClass(baziA.hour?.[0])">{{ baziA.hour?.[0] || '-' }}</span></td>
                </tr>
                <tr>
                  <td class="label-cell">地支</td>
                  <td><span class="pillar-char" :class="getElementClass(baziA.year?.[1])">{{ baziA.year?.[1] || '-' }}</span></td>
                  <td><span class="pillar-char" :class="getElementClass(baziA.month?.[1])">{{ baziA.month?.[1] || '-' }}</span></td>
                  <td><span class="pillar-char" :class="getElementClass(baziA.day?.[1])">{{ baziA.day?.[1] || '-' }}</span></td>
                  <td><span class="pillar-char" :class="getElementClass(baziA.hour?.[1])">{{ baziA.hour?.[1] || '-' }}</span></td>
                </tr>
                <tr class="wuxing-row">
                  <td class="label-cell">五行</td>
                  <td>{{ ganWuxingMap[baziA.year?.[0]] || '' }} {{ ganWuxingMap[baziA.year?.[1]] || '' }}</td>
                  <td>{{ ganWuxingMap[baziA.month?.[0]] || '' }} {{ ganWuxingMap[baziA.month?.[1]] || '' }}</td>
                  <td>{{ ganWuxingMap[baziA.day?.[0]] || '' }} {{ ganWuxingMap[baziA.day?.[1]] || '' }}</td>
                  <td>{{ ganWuxingMap[baziA.hour?.[0]] || '' }} {{ ganWuxingMap[baziA.hour?.[1]] || '' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Person B -->
      <div class="person-card">
        <div class="person-card-title">
          <span class="person-icon">👩</span> 方位乙
        </div>
        <div class="person-form">
          <div class="date-row">
            <el-select v-model="personB.year" placeholder="年" filterable clearable size="default" class="date-select">
              <el-option v-for="y in yearOptions" :key="y" :label="y + '年'" :value="y" />
            </el-select>
            <el-select v-model="personB.month" placeholder="月" clearable size="default" class="date-select">
              <el-option v-for="m in 12" :key="m" :label="m + '月'" :value="m" />
            </el-select>
            <el-select v-model="personB.day" placeholder="日" clearable size="default" class="date-select">
              <el-option v-for="d in daysInMonthB" :key="d" :label="d + '日'" :value="d" />
            </el-select>
          </div>
          <div class="hour-row">
            <el-select v-model="personB.hour" placeholder="时辰" clearable size="default" class="hour-select">
              <el-option label="子时 (23-01)" value="23" />
              <el-option label="丑时 (01-03)" value="1" />
              <el-option label="寅时 (03-05)" value="3" />
              <el-option label="卯时 (05-07)" value="5" />
              <el-option label="辰时 (07-09)" value="7" />
              <el-option label="巳时 (09-11)" value="9" />
              <el-option label="午时 (11-13)" value="11" />
              <el-option label="未时 (13-15)" value="13" />
              <el-option label="申时 (15-17)" value="15" />
              <el-option label="酉时 (17-19)" value="17" />
              <el-option label="戌时 (19-21)" value="19" />
              <el-option label="亥时 (21-23)" value="21" />
            </el-select>
          </div>
          <!-- 四柱八字表格 -->
          <div v-if="baziB" class="bazi-table-wrap">
            <table class="bazi-preview-table">
              <thead>
                <tr>
                  <th></th>
                  <th>年柱</th>
                  <th>月柱</th>
                  <th>日柱</th>
                  <th>时柱</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="label-cell">天干</td>
                  <td><span class="pillar-char" :class="getElementClass(baziB.year?.[0])">{{ baziB.year?.[0] || '-' }}</span></td>
                  <td><span class="pillar-char" :class="getElementClass(baziB.month?.[0])">{{ baziB.month?.[0] || '-' }}</span></td>
                  <td><span class="pillar-char" :class="getElementClass(baziB.day?.[0])">{{ baziB.day?.[0] || '-' }}</span></td>
                  <td><span class="pillar-char" :class="getElementClass(baziB.hour?.[0])">{{ baziB.hour?.[0] || '-' }}</span></td>
                </tr>
                <tr>
                  <td class="label-cell">地支</td>
                  <td><span class="pillar-char" :class="getElementClass(baziB.year?.[1])">{{ baziB.year?.[1] || '-' }}</span></td>
                  <td><span class="pillar-char" :class="getElementClass(baziB.month?.[1])">{{ baziB.month?.[1] || '-' }}</span></td>
                  <td><span class="pillar-char" :class="getElementClass(baziB.day?.[1])">{{ baziB.day?.[1] || '-' }}</span></td>
                  <td><span class="pillar-char" :class="getElementClass(baziB.hour?.[1])">{{ baziB.hour?.[1] || '-' }}</span></td>
                </tr>
                <tr class="wuxing-row">
                  <td class="label-cell">五行</td>
                  <td>{{ ganWuxingMap[baziB.year?.[0]] || '' }} {{ ganWuxingMap[baziB.year?.[1]] || '' }}</td>
                  <td>{{ ganWuxingMap[baziB.month?.[0]] || '' }} {{ ganWuxingMap[baziB.month?.[1]] || '' }}</td>
                  <td>{{ ganWuxingMap[baziB.day?.[0]] || '' }} {{ ganWuxingMap[baziB.day?.[1]] || '' }}</td>
                  <td>{{ ganWuxingMap[baziB.hour?.[0]] || '' }} {{ ganWuxingMap[baziB.hour?.[1]] || '' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- 开始合婚按钮 -->
    <div class="action-bar">
      <el-button
        type="primary"
        size="large"
        :loading="isAnalyzing"
        class="analyze-btn"
        @click="startAnalysis"
      >
        {{ isAnalyzing ? 'AI 合婚分析中...' : '💫 开始合婚' }}
      </el-button>
    </div>

    <!-- 分析结果 -->
    <div v-if="analysisResult" class="result-card">
      <div class="result-header">合婚分析结果</div>
      <div class="result-body" v-html="renderedAnalysis"></div>
      <div class="result-actions">
        <el-button type="primary" @click="shareVisible = true">📣 分享合婚结果</el-button>
      </div>
    </div>

    <!-- 结果分享卡 -->
    <ShareResult
      v-model:visible="shareVisible"
      scene-label="八字合婚"
      :headline="shareHeadline"
      :subline="shareSubline"
      :tags="shareTags"
      :symbol="shareSymbol"
      page="bazi"
    />
  </div>
</template>

<script setup>
import { ref, reactive, computed, watch } from 'vue'
import { ElMessage } from 'element-plus'
import lunisolar from 'lunisolar'
import zhCn from 'lunisolar/locale/zh-cn'
import { char8ex } from '@lunisolar/plugin-char8ex'
import { marked } from 'marked'
import { useAuthGuard } from '@/composables/useAuthGuard'
import { ShareResult } from '@/components/common'

const { requireLogin } = useAuthGuard()

// 初始化 lunisolar
lunisolar.locale(zhCn)
lunisolar.extend(char8ex)

// marked 配置
marked.setOptions({
  gfm: true,
  breaks: true,
  mangle: false,
  headerIds: false,
  smartLists: true,
  smartypants: true
})

// 年份选项 1920-2030
const yearOptions = Array.from({ length: 111 }, (_, i) => 1920 + i)

// 每月天数计算
const getDaysInMonth = (year, month) => {
  if (!year || !month) return 31
  return new Date(year, month, 0).getDate()
}

// 人物数据
const personA = reactive({ year: null, month: null, day: null, hour: null })
const personB = reactive({ year: null, month: null, day: null, hour: null })

const daysInMonthA = computed(() => getDaysInMonth(personA.year, personA.month))
const daysInMonthB = computed(() => getDaysInMonth(personB.year, personB.month))

// 天干地支 → 五行映射（模板中也用到）
const ganWuxingMap = {
  '甲': '木', '乙': '木', '丙': '火', '丁': '火',
  '戊': '土', '己': '土', '庚': '金', '辛': '金',
  '壬': '水', '癸': '水',
  '子': '水', '丑': '土', '寅': '木', '卯': '木',
  '辰': '土', '巳': '火', '午': '火', '未': '土',
  '申': '金', '酉': '金', '戌': '土', '亥': '水'
}

// 五行配色（与 BaziPanel 一致）
const getElementClass = (char) => {
  const elementMap = {
    '甲': 'element-wood yang', '乙': 'element-wood yin',
    '丙': 'element-fire yang', '丁': 'element-fire yin',
    '戊': 'element-earth yang', '己': 'element-earth yin',
    '庚': 'element-metal yang', '辛': 'element-metal yin',
    '壬': 'element-water yang', '癸': 'element-water yin',
    '子': 'element-water yang', '丑': 'element-earth yin',
    '寅': 'element-wood yang', '卯': 'element-wood yin',
    '辰': 'element-earth yang', '巳': 'element-fire yin',
    '午': 'element-fire yang', '未': 'element-earth yin',
    '申': 'element-metal yang', '酉': 'element-metal yin',
    '戌': 'element-earth yang', '亥': 'element-water yin'
  }
  return elementMap[char] || ''
}

// 根据出生日期计算四柱八字
const calcBazi = (person) => {
  try {
    const { year, month, day, hour } = person
    if (!year || !month || !day) return null

    const date = new Date(year, month - 1, day)
    const hourVal = hour !== null ? parseInt(hour) : 12 // 默认午时
    date.setHours(hourVal)

    const lsr = lunisolar(date)
    const c8ex = lsr.char8ex(1) // gender doesn't matter for basic four pillars

    // 提取四柱天干地支
    const yearPillar = (c8ex.year.stem.name || '') + (c8ex.year.branch.name || '')
    const monthPillar = (c8ex.month.stem.name || '') + (c8ex.month.branch.name || '')
    const dayPillar = (c8ex.day.stem.name || '') + (c8ex.day.branch.name || '')
    const hourPillar = (c8ex.hour.stem.name || '') + (c8ex.hour.branch.name || '')

    if (!yearPillar || !dayPillar) return null

    // 提取五行分布
    const stems = [c8ex.year.stem.name, c8ex.month.stem.name, c8ex.day.stem.name, c8ex.hour.stem.name]
    const branches = [c8ex.year.branch.name, c8ex.month.branch.name, c8ex.day.branch.name, c8ex.hour.branch.name]
    const wuxing = { '金': 0, '木': 0, '水': 0, '火': 0, '土': 0 }

    ;[...stems, ...branches].forEach(c => {
      const wx = ganWuxingMap[c]
      if (wx) wuxing[wx]++
    })

    // 公历日期字符串
    const solarDate = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')} ${String(hourVal).padStart(2, '0')}:00`

    // 扁平结构，模板直接用 baziA.year
    return {
      solarDate,
      year: yearPillar,
      month: monthPillar,
      day: dayPillar,
      hour: hourPillar,
      wuxing
    }
  } catch (e) {
    console.error('计算八字失败:', e)
    return null
  }
}

// 实时计算两人八字
const baziA = computed(() => calcBazi(personA))
const baziB = computed(() => calcBazi(personB))

// 状态
const isAnalyzing = ref(false)
const analysisResult = ref('')

// 渲染 Markdown
const renderedAnalysis = computed(() => {
  return analysisResult.value ? marked(analysisResult.value) : ''
})

/* ---------- 结果分享卡（文案由双方已算出的八字拼装, 不发新请求） ---------- */
const shareVisible = ref(false)
const shareHeadline = computed(() => {
  const sA = baziA.value?.day?.[0]
  const sB = baziB.value?.day?.[0]
  if (!sA || !sB) return '我们的八字合婚分析'
  return `我们的八字合婚分析：${sA}${ganWuxingMap[sA] || ''} × ${sB}${ganWuxingMap[sB] || ''}`
})
const shareSubline = computed(() => {
  const dA = baziA.value?.day
  const dB = baziB.value?.day
  if (!dA || !dB) return 'AI 合婚解读'
  return `日柱 ${dA} × ${dB} 四柱对照`
})
const shareTags = computed(() => {
  const dA = baziA.value?.day
  const dB = baziB.value?.day
  if (!dA || !dB) return []
  return [`日柱${dA}`, `日柱${dB}`, `${ganWuxingMap[dA[0]] || ''}×${ganWuxingMap[dB[0]] || ''}`]
})
// 视觉主体: 双方日柱对, 如「甲子 × 乙丑」
const shareSymbol = computed(() => {
  const dA = baziA.value?.day
  const dB = baziB.value?.day
  return dA && dB ? `${dA} × ${dB}` : ''
})

// 开始合婚分析
const startAnalysis = async () => {
  // 支付守卫
  if (!requireLogin('heBazi')) return

  if (!personA.year || !personA.month || !personA.day || personA.hour === null) {
    ElMessage.warning('请完整填写方位甲的出生日期和时辰')
    return
  }
  if (!personB.year || !personB.month || !personB.day || personB.hour === null) {
    ElMessage.warning('请完整填写方位乙的出生日期和时辰')
    return
  }

  const dataA = calcBazi(personA)
  const dataB = calcBazi(personB)
  if (!dataA || !dataB) {
    ElMessage.error('八字计算失败，请检查输入的日期')
    return
  }

  isAnalyzing.value = true
  analysisResult.value = ''

  try {
    const response = await fetch('/api/ai/heBazi/analyze', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({
        personA: { solarDate: dataA.solarDate, bazi: { year: dataA.year, month: dataA.month, day: dataA.day, hour: dataA.hour }, wuxing: dataA.wuxing },
        personB: { solarDate: dataB.solarDate, bazi: { year: dataB.year, month: dataB.month, day: dataB.day, hour: dataB.hour }, wuxing: dataB.wuxing }
      })
    })

    const result = await response.json()

    if (!response.ok) {
      throw new Error(result.detail || result.message || '分析请求失败')
    }

    if (result.success && result.analysis) {
      analysisResult.value = result.analysis
    } else {
      ElMessage.error(result.message || '分析失败，请稍后重试')
    }
  } catch (e) {
    console.error('合婚分析失败:', e)
    if (e.message.includes('401') || e.message.includes('未登录')) {
      requireLogin('heBazi')
    } else {
      ElMessage.error(e.message || '合婚分析失败，请稍后重试')
    }
  } finally {
    isAnalyzing.value = false
  }
}
</script>

<style lang="scss" scoped>
.he-bazi-panel {
  padding: 1.5rem;
  max-width: 960px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 1rem;
  }
}

.persons-input {
  display: flex;
  gap: 1.5rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
}

.person-card {
  flex: 1;
  background: var(--fh-card-bg);
  border: var(--fh-card-border);
  border-radius: 12px;
  padding: 1.25rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  }
}

.person-card-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--fh-accent);
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.person-icon {
  font-size: 1.2rem;
}

.person-form {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.date-row {
  display: flex;
  gap: 0.5rem;

  .date-select {
    flex: 1;
    min-width: 0;
  }

  @media (max-width: 768px) {
    flex-wrap: wrap;
    .date-select {
      flex: 1 1 calc(33% - 0.34rem);
      min-width: 70px;
    }
  }
}

.hour-row {
  .hour-select {
    width: 100%;
  }
}

// 四柱八字表格
.bazi-table-wrap {
  margin-top: 1rem;
  overflow-x: auto;
}

.bazi-preview-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;

  th {
    padding: 0.5rem 0.4rem;
    text-align: center;
    font-weight: 600;
    color: var(--fh-accent);
    background: rgba(0, 0, 0, 0.03);
    border-bottom: 1px solid var(--fh-card-border, #e5e5e5);

    &:first-child {
      text-align: left;
      width: 3.5rem;
    }
  }

  td {
    padding: 0.6rem 0.4rem;
    text-align: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.04);
    color: var(--fh-text);
  }

  .label-cell {
    font-size: 0.8rem;
    color: var(--fh-text-secondary);
    text-align: left;
    font-weight: 500;
  }

  .pillar-char {
    font-size: 1.15rem;
    font-weight: 700;
    letter-spacing: 1px;
  }

  .wuxing-row td {
    font-size: 0.8rem;
    color: var(--fh-text-secondary);
  }

  @media (max-width: 768px) {
    font-size: 0.8rem;

    th, td {
      padding: 0.4rem 0.2rem;
    }

    .pillar-char {
      font-size: 1rem;
    }
  }
}

// 五行元素样式（与 BaziPanel 一致）
.element {
  &-wood {
    &.yang { color: #2E7D32; text-shadow: 0 0 8px rgba(46, 125, 50, 0.6); }
    &.yin { color: #66BB6A; text-shadow: 0 0 8px rgba(102, 187, 106, 0.6); }
  }
  &-fire {
    &.yang { color: #D84315; text-shadow: 0 0 8px rgba(216, 67, 21, 0.6); }
    &.yin { color: #FF7043; text-shadow: 0 0 8px rgba(255, 112, 67, 0.6); }
  }
  &-earth {
    &.yang { color: #F9A825; text-shadow: 0 0 8px rgba(249, 168, 37, 0.6); }
    &.yin { color: #FFD54F; text-shadow: 0 0 8px rgba(255, 213, 79, 0.6); }
  }
  &-metal {
    &.yang { color: #90A4AE; text-shadow: 0 0 8px rgba(144, 164, 174, 0.6); }
    &.yin { color: #B0BEC5; text-shadow: 0 0 8px rgba(176, 190, 197, 0.6); }
  }
  &-water {
    &.yang { color: #1565C0; text-shadow: 0 0 8px rgba(21, 101, 192, 0.6); }
    &.yin { color: #42A5F5; text-shadow: 0 0 8px rgba(66, 165, 245, 0.6); }
  }
}

// 操作栏
.action-bar {
  text-align: center;
  margin: 2rem 0;
}

.analyze-btn {
  min-width: 200px;
  height: 48px;
  font-size: 1.05rem;
  font-weight: 600;
  border-radius: 24px;
  background: var(--fh-accent);
  border-color: var(--fh-accent);
  color: #fff;
  transition: all 0.3s ease;

  &:hover {
    background: var(--fh-accent-hover);
    border-color: var(--fh-accent-hover);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0);
  }
}

// 分析结果卡片
.result-card {
  background: var(--fh-card-bg);
  border: var(--fh-card-border);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  margin-top: 1rem;
}

.result-header {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--fh-accent);
  padding: 1rem 1.5rem;
  border-bottom: 1px solid var(--fh-card-border, #e5e5e5);
}

// 分享按钮区（跟随 result-card 既有风格）
.result-actions {
  padding: 1rem 1.5rem;
  border-top: 1px dashed var(--fh-card-border, #e5e5e5);
}

.result-body {
  padding: 1.5rem;
  color: var(--fh-text);
  line-height: 1.8;
  font-size: 0.95rem;

  :deep(h1),
  :deep(h2),
  :deep(h3),
  :deep(h4) {
    color: var(--fh-text-bright);
    margin: 1.5em 0 0.5em;
  }

  :deep(h1) { font-size: 1.4rem; }
  :deep(h2) { font-size: 1.2rem; border-bottom: 1px dashed var(--fh-card-border, #e5e5e5); padding-bottom: 0.3em; }
  :deep(h3) { font-size: 1.05rem; }

  :deep(p) {
    margin: 0.6em 0;
  }

  :deep(ul),
  :deep(ol) {
    padding-left: 1.5em;
    margin: 0.5em 0;
  }

  :deep(li) {
    margin: 0.3em 0;
  }

  :deep(strong) {
    color: var(--fh-accent);
  }

  :deep(blockquote) {
    margin: 1em 0;
    padding: 0.5em 1em;
    border-left: 3px solid var(--fh-accent);
    background: var(--fh-accent-bg);
    border-radius: 0 8px 8px 0;
    color: var(--fh-text-secondary);
  }

  :deep(hr) {
    border: none;
    border-top: 1px dashed var(--fh-card-border, #e5e5e5);
    margin: 1.5em 0;
  }

  @media (max-width: 768px) {
    padding: 1rem;

    :deep(h1) { font-size: 1.2rem; }
    :deep(h2) { font-size: 1.05rem; }
  }
}
</style>
